// extracted by mini-css-extract-plugin
export var clickThrough = "_y0-2";
export var fallback = "_y0-5";
export var frame = "_y0-3";
export var frameCell = "_y0-1";
export var overlay = "_y0-4";
export var wrapper = "_y0-0";